"use strict";

const HEADER = document.getElementById("header");

let headerRects = HEADER.getBoundingClientRect(),
	headerHeight = headerRects.height + headerRects.top;

let lastScrollTop = 0;
let currentScroll = window.scrollY || window.pageYOffset;

new ResizeObserver(() => {
	headerRects = HEADER.getBoundingClientRect();
	headerHeight = headerRects.height + headerRects.top;
	document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
}).observe(HEADER);

// Utilities
const debounce = (fn, ms = 150) => {
	let timeoutId;
	return (...args) => {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => fn(...args), ms);
	};
};

const animateTo = (target) => {
	if (!window.lenis) return;

	window.lenis.scrollTo(target, {
		offset: headerHeight * -2,
		duration: 1.4,
		easing: t => t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2
	});
};

const scrollW = (scrollTop) => {
	if (scrollTop < 80) {
		HEADER.classList.remove('up', 'down');
	} else {
		HEADER.classList.toggle('down', scrollTop > lastScrollTop);
		HEADER.classList.toggle('up', scrollTop <= lastScrollTop);
	}
	lastScrollTop = Math.max(scrollTop, 0);
};

// Event Listeners
document.addEventListener("change", (e) => {
	const dropdown = e.target.closest(".js-dropdown");
	if (dropdown && e.target.dataset.label) {
		dropdown.firstElementChild.textContent = e.target.dataset.label;
		e.target.blur();
	}
});

document.addEventListener("reset", (e) => {
	e.target.querySelectorAll(".js-dropdown").forEach(dropdown => {
		const defaultItem = dropdown.querySelector("input[checked]") || dropdown.querySelector("[data-label]");
		if (defaultItem && defaultItem.dataset.label) {
			dropdown.firstElementChild.textContent = defaultItem.dataset.label;
		}
	});
});

window.modalForm = function (formData) {
	const formItem = formData.find(item => item.name === "form_id");
	if (!formItem) return;

	const modalForm = document.getElementById(`form_id-${formItem.value}`).closest(".modal-form");
	if (modalForm && modalForm.dataset.redirect) {
		window.open(modalForm.dataset.redirect, "_blank");
	}
};

(() => {
	window.lenis = new Lenis({
		duration: 1.2,
		smooth: true,
		smoothTouch: true
	});

	const raf = (time) => {
		window.lenis.raf(time);
		requestAnimationFrame(raf);
	};
	requestAnimationFrame(raf);

	scrollW(currentScroll);

	window.lenis.on("scroll", ({ scroll }) => {
		currentScroll = scroll;
		scrollW(scroll);
	});

	window.location.hash && animateTo(window.location.hash);

	const toggleGroups = new Map();

	const getPanel = (el) => {
		const target = el.dataset.target;
		if (target) return document.getElementById(target);
		const next = el.nextElementSibling;
		return (next && next.hasAttribute('aria-expanded')) ? next : null;
	};

	const deactivate = (currentlyActive) => {
		currentlyActive.summary.classList.remove("active");
		currentlyActive.content && currentlyActive.content.setAttribute("aria-expanded", false);
	};

	document.addEventListener("click", (e) => {
		// Hash Links
		const cta = e.target.closest('[href*="#"]:not([data-lbx])');
		if (cta && cta.hash.length > 1) {
			if (document.getElementById(cta.hash.substring(1))) {
				e.preventDefault();
				animateTo(cta.hash);
				return;
			}
		}

		// Toggle Buttons
		const el = e.target.closest(".js-toggle-active");
		if (el) {
			const groupKey = el.dataset.group || el;
			const action = el.dataset.action || "toggle";
			const currentlyActive = toggleGroups.get(groupKey);

			if (action === "close") {
				if (currentlyActive) {
					deactivate(currentlyActive);
					toggleGroups.delete(groupKey);
				}
				return;
			}

			currentlyActive && currentlyActive.summary !== el && deactivate(currentlyActive);

			const panel = getPanel(el);

			if (action === "open") {
				el.classList.add("active");
				if (panel) panel.setAttribute("aria-expanded", "true");
				toggleGroups.set(groupKey, { summary: el, content: panel });
				return;
			}

			const nowActive = el.classList.toggle("active");
			panel && panel.setAttribute("aria-expanded", nowActive);

			if (nowActive) {
				toggleGroups.set(groupKey, { summary: el, content: panel });
			} else {
				toggleGroups.delete(groupKey);
			}
		}
	});

	// Observers
	const animationObserver = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add("fade-in");
				animationObserver.unobserve(entry.target);
			}
		});
	});

	const resizeObserver = new ResizeObserver(entries => {
		entries.forEach(entry => {
			const el = entry.target;
			const targetEl = el.dataset.target ? document.getElementById(el.dataset.target) : el;
			if (targetEl) {
				targetEl.style.setProperty("--offset", `${el.scrollHeight}px`);
			}
		});
	});

	// Trackers
	const initializedTrackers = new WeakSet();

	const updateTrackerPosition = (element, target) => {
		if (!target) return;
		element.style.cssText = `left: ${target.offsetLeft}px; width: ${target.offsetWidth}px;`;
	};

	const initTracker = (tracker) => {
		if (initializedTrackers.has(tracker)) return;
		initializedTrackers.add(tracker);

		const parent = tracker.parentElement;
		let activeTab = parent.querySelector(".active") || parent.firstElementChild;

		parent.addEventListener("mouseover", (e) => {
			const target = e.target.closest("button");
			if (target) updateTrackerPosition(tracker, target);
		});

		parent.addEventListener("mouseout", () => updateTrackerPosition(tracker, activeTab));

		parent.addEventListener("focusin", (e) => {
			const target = e.target.closest("button");
			if (target) updateTrackerPosition(tracker, target);
		});

		parent.addEventListener("focusout", (e) => {
			if (!parent.contains(e.relatedTarget)) updateTrackerPosition(tracker, activeTab);
		});

		updateTrackerPosition(tracker, activeTab);

		parent.addEventListener("click", (e) => {
			const target = e.target.closest("button");
			if (!target || target === activeTab) return;

			activeTab.classList.remove("active");
			target.classList.add("active");
			activeTab = target;
		});
	};

	// Dynamic Element Initializer
	const addAnimations = (selector, behavior = "") => {
		document.querySelectorAll(`${selector}:not(.animate-fade)`).forEach(item => item.classList.add("animate-fade", behavior));
	};

	const initDynamicElements = (container = document) => {
		container.querySelectorAll("p:not(.js-obs-p)").forEach(p => {
			p.classList.add("js-obs-p");
			if (p.children.length === 0 && p.textContent.trim() === '') p.remove();
		});

		addAnimations(".global-sitemap", "top");
		addAnimations(".text-modules-wrapper", "top");

		container.querySelectorAll(".animate-fade:not(.js-obs-fade)").forEach(el => {
			el.classList.add("js-obs-fade");
			animationObserver.observe(el);
		});

		container.querySelectorAll(".js-offset:not(.js-obs-offset)").forEach(el => {
			el.classList.add("js-obs-offset");
			resizeObserver.observe(el);
		});

		container.querySelectorAll(".js-tracker:not(.js-obs-tracker)").forEach(el => {
			if (!el.offsetParent) return;

			el.classList.add("js-obs-tracker");
			initTracker(el);
		});

		container.querySelectorAll(".js-toggle-active.active:not(.js-obs-toggle)").forEach(el => {
			el.classList.add("js-obs-toggle");
			const key = el.dataset.group || el;
			toggleGroups.set(key, { summary: el, content: getPanel(el) });
		});

		const mindtripContainer = container.querySelector("#mindtrip-container:not([data-lenis-prevent])");
		mindtripContainer && mindtripContainer.setAttribute("data-lenis-prevent", "true");
	};

	initDynamicElements();

	let observerTimeout;
	const domObserver = new MutationObserver(mutations => {
		const shouldUpdate = mutations.some(mutation =>
			Array.from(mutation.addedNodes).some(node => node.nodeType === 1)
		);

		if (shouldUpdate) {
			clearTimeout(observerTimeout);
			observerTimeout = setTimeout(() => {
				initDynamicElements();

				for (const [key, val] of toggleGroups.entries()) {
					if (!document.contains(val.summary)) {
						toggleGroups.delete(key);
					}
				}
			}, 50);
		}
	});

	domObserver.observe(document.body, { childList: true, subtree: true });

	// Custom Cursor
	if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
		const cursor = document.createElement("div");
		cursor.className = "cursor";
		document.body.appendChild(cursor);

		const states = ["cursor--expand", "cursor--drag", "cursor--prev", "cursor--next"];

		const resetCursor = () => {
			cursor.classList.remove("cursor--active", ...states);
		};

		window.addEventListener("pointerdown", () => cursor.classList.add("cursor--clicking"), { passive: true });
		window.addEventListener("pointerup", () => cursor.classList.remove("cursor--clicking"), { passive: true });

		document.addEventListener("pointerover", (e) => {
			const target = e.target.closest(".js-cursor-expand, .js-cursor-drag, .js-cursor-prev, .js-cursor-next");

			resetCursor();

			if (target) {
				cursor.classList.add("cursor--active");

				if (target.closest(".js-cursor-expand")) cursor.classList.add("cursor--expand");
				else if (target.closest(".js-cursor-drag")) cursor.classList.add("cursor--drag");
				else if (target.closest(".js-cursor-prev")) cursor.classList.add("cursor--prev");
				else if (target.closest(".js-cursor-next")) cursor.classList.add("cursor--next");
			}
		});

		document.addEventListener("pointerout", (e) => {
			const to = e.relatedTarget;
			if (!to || !to.closest(".js-cursor-expand, .js-cursor-drag, .js-cursor-prev, .js-cursor-next"))
				resetCursor();
		});

		document.addEventListener("mouseleave", resetCursor);
		window.addEventListener("pointercancel", resetCursor);

		let ticking = false;

		document.addEventListener("pointermove", (e) => {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(() => {
				cursor.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
				ticking = false;
			});
		}, { passive: true });
	}
})();